export default __webpack_public_path__ + "static/6-fdee5db6c5d5b6a6cca57ad916aab093.jpg";